







































































import { Vue, deviceID } from "../../constants/constants";
import { constants } from "http2";
import {
  BasketLoadersEnum,
  genericErrorsEnum
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("verify-credit-card", {
  data() {
    return {
      staticContent,
      hasError: false,
      basketLoader: BasketLoadersEnum,
      month: "",
      year: "",
      submitted: false,
      cardExpiryDate:'',
    };
  },
 mounted(){
  
 },
  computed: {
    bindConditionalClasses(){
      return this.$root.bindConditionalClasses;
    },
    basket() {
      return this.$store.getters.getBasket;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    },
    getVerificationData(){
      return this.$store.state.cardVerification
    },
    creditCardNumber(){
     return this.basket.ref.card && this.basket.ref.card.data.number.substr(12, 4)
    }
    
  },
  methods: {
    
        handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
         this.cardExpiryDate=this.month.length==1?this.year+"0"+this.month:this.year+""+this.month
          let data={
            uuid:this.basket.ref.card.uuid,
            date:{
              expiryDate:this.cardExpiryDate
            }
          }
          
            this.$store.dispatch('TRUST_USER_CREDIT_CARDS',data);

        }
      });
    },
   

    modalToggler(modal, method) {
      this.$root.modalToggler(modal, method);
    },
 
  }
});
